import React, { useState } from "react";
import styled from "styled-components";
import { Spinner, Table as BsTable } from "react-bootstrap";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import IconContainer from "../../organisms/IconContainer";
import { ItemListadoAsistenciaDiariaSpa } from "../../../services/asistenciaSpaServicios";
import { PrettyHorarioSpa } from "../../../services/agendamientosSpaServicios";

function Table({
  items,
  isLoading,
  isSuccess,
  onAsistioChange,
  onReagendarClick,
}: {
  items: ItemListadoAsistenciaDiariaSpa[];
  isLoading: boolean;
  isSuccess: boolean;
  onAsistioChange: (payload: { id: string; asistio: boolean }) => void;
  onReagendarClick: (item: ItemListadoAsistenciaDiariaSpa) => void;
}) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>No.</StyledColHeader>
          <StyledColHeader>Mascota</StyledColHeader>
          <StyledColHeader>Propietario</StyledColHeader>
          <StyledColHeader>Raza</StyledColHeader>
          <StyledColHeader>Horario</StyledColHeader>
          <StyledColHeader>Ingresó</StyledColHeader>
          <StyledColHeader></StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {isLoading && <LoadingItem />}
        {isSuccess &&
          items.map((_, i) => (
            <TableItem
              key={_.idMascota}
              item={_}
              no={i + 1}
              onAsistioChange={onAsistioChange}
              onReagendarClick={onReagendarClick}
            />
          ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({
  no,
  item,
  onAsistioChange,
  onReagendarClick,
}: {
  no: number;
  item: ItemListadoAsistenciaDiariaSpa;
  onAsistioChange: (payload: { id: string; asistio: boolean }) => void;
  onReagendarClick: (item: ItemListadoAsistenciaDiariaSpa) => void;
}) {
  const [currentItem, setCurrentItem] = useState(item);

  const onIncresoToggle = (asistio: boolean) => {
    setCurrentItem((prevItem) => {
      const newItem: ItemListadoAsistenciaDiariaSpa = {
        ...prevItem,
        asistio,
      };
      return newItem;
    });

    onAsistioChange({ id: item.id, asistio });
  };

  return (
    <DynamicRow isSuccess={currentItem.asistio}>
      <StyledCell>{no}</StyledCell>
      <StyledCell>{item.nombreMascota}</StyledCell>
      <StyledCell>{item.nombrePropietario}</StyledCell>
      <StyledCell>{item.raza}</StyledCell>
      <StyledCell>{PrettyHorarioSpa[item.horario]}</StyledCell>
      <StyledCell>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={currentItem.asistio}
            id="flexCheckDefault"
            onChange={() => {
              onIncresoToggle(!currentItem.asistio);
            }}
          />
        </div>
      </StyledCell>
      <ReagendamientoColumn
        item={currentItem}
        onReagendarClick={onReagendarClick}
      />
    </DynamicRow>
  );
}

function ReagendamientoColumn({
  item,
  onReagendarClick,
}: {
  item: ItemListadoAsistenciaDiariaSpa;
  onReagendarClick: (item: ItemListadoAsistenciaDiariaSpa) => void;
}) {
  const onButtonClick = () => {
    onReagendarClick(item);
  };

  if (item.asistio) {
    return <StyledCell />;
  } else {
    return (
      <StyledCell>
        <IconContainer onClick={onButtonClick} style={{ cursor: "pointer" }}>
          <EventRepeatIcon />
        </IconContainer>
      </StyledCell>
    );
  }
}

function LoadingCell() {
  return (
    <StyledCell>
      <Spinner animation={"border"} />
    </StyledCell>
  );
}

function LoadingItem() {
  return (
    <StyledRow>
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
      <LoadingCell />
    </StyledRow>
  );
}

function DynamicRow({
  children,
  isSuccess,
}: {
  children: React.ReactNode;
  isSuccess: boolean;
}) {
  if (isSuccess) {
    return <StyledSuccessRow>{children}</StyledSuccessRow>;
  } else {
    return <StyledRow>{children}</StyledRow>;
  }
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

const StyledSuccessRow = styled(StyledRow)`
  background-color: ${(props) => props.theme.colors.successShadow};
`;

export default Table;
